/**
 * Analytics utility for Antiaging by BB.
 * - trackEvent fires events to dataLayer (GTM) and fbq (Meta Pixel) if present.
 * - trackPageview also POSTs to our internal /api/analytics/pageview for the admin dashboard.
 */
import { api } from "../lib/api";

const SESSION_KEY = "aabb_session_id_v1";
function sessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = (crypto?.randomUUID && crypto.randomUUID()) || (Date.now() + "-" + Math.random().toString(36).slice(2));
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function trackEvent(eventName, payload = {}) {
  try {
    if (typeof window !== "undefined") {
      if (window.dataLayer) window.dataLayer.push({ event: eventName, ...payload });
      if (typeof window.fbq === "function") window.fbq("track", eventName, payload);
    }
  } catch (e) {
    // analytics must never break the app
    // eslint-disable-next-line no-console
    console.warn("trackEvent error:", e);
  }
}

export function trackPageview(path) {
  trackEvent("page_view", { path });
  // Internal pageview tracker — fire-and-forget
  try {
    api.post("/analytics/pageview", {
      path,
      referrer: document.referrer || "",
      sessionId: sessionId(),
    }).catch(() => {});
  } catch (e) { /* noop */ }
}
